

































import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "LaunchApp",
})
export default class LaunchApp extends Vue {
  clickLaunchApp() {
    window.open(`${process.env.VUE_APP_UNIVERSAL_LINK}${this.$route.fullPath}`);
  }
  clickDownloadApp() {
    const ua = navigator.userAgent.toLowerCase();
    const isIPhone =
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i);
    if (isIPhone) {
      window.open(
        "https://apps.apple.com/jp/app/%E3%82%AF%E3%83%AD%E3%82%B9%E3%82%A2%E3%82%A4%E3%83%87%E3%82%A3/id1495147544"
      );
    } else {
      //const isAndroid = ua.includes('android')
      window.open("https://play.google.com/store/apps/details?id=me.x.id");
    }
  }
  clickDontHaveAccount() {
    this.$router.push("/");
  }
}
